var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6903 10.6793C15.4565 10.6793 15.2669 10.8688 15.2669 11.1027V14.8619C15.2661 15.5632 14.698 16.1314 13.9968 16.1321H2.11694C1.4157 16.1314 0.847603 15.5632 0.846776 14.8619V3.82885C0.847603 3.12778 1.4157 2.55952 2.11694 2.55869H5.87616C6.11002 2.55869 6.29955 2.36916 6.29955 2.1353C6.29955 1.90161 6.11002 1.71191 5.87616 1.71191H2.11694C0.948323 1.71324 0.00132309 2.66024 0 3.82885V14.8621C0.00132309 16.0307 0.948323 16.9777 2.11694 16.979H13.9968C15.1654 16.9777 16.1124 16.0307 16.1137 14.8621V11.1027C16.1137 10.8688 15.9242 10.6793 15.6903 10.6793Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9465 0.622507C15.2024 -0.121565 13.9961 -0.121565 13.252 0.622507L5.69847 8.17601C5.64671 8.22778 5.60933 8.29195 5.58981 8.3624L4.5965 11.9485C4.55565 12.0955 4.59717 12.2529 4.705 12.3609C4.81299 12.4688 4.97044 12.5103 5.11747 12.4696L8.70354 11.4761C8.77399 11.4566 8.83816 11.4192 8.88993 11.3675L16.4433 3.81379C17.1862 3.06923 17.1862 1.86389 16.4433 1.11933L15.9465 0.622507ZM6.621 8.45122L12.803 2.26909L14.7967 4.26282L8.61456 10.4449L6.621 8.45122ZM6.22275 9.25036L7.81558 10.8434L5.61231 11.4538L6.22275 9.25036ZM15.8446 3.2151L15.3956 3.66412L13.4017 1.67023L13.8508 1.2212C14.2641 0.807904 14.9343 0.807904 15.3476 1.2212L15.8446 1.71802C16.2572 2.13182 16.2572 2.80147 15.8446 3.2151Z",
    fill: "#74A3C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.940bd6a4415d14731d01db755e171ea5.svg";
export { ForwardRef as ReactComponent };